import React from 'react';
import ReactDOM from 'react-dom';

function BillingModal({ isOpen, onClose, title, children }) {
    if (!isOpen) return null;

    return ReactDOM.createPortal(
        <div className="modal__billing fixed inset-0 z-50 flex overflow-auto bg-black/50">
            <div
                className="relative bg-white dark:bg-gray-800 w-full max-w-lg m-auto flex-col flex app-surface rounded-lg shadow-lg">

                <div className="px-5 py-3 border-b border-gray-200 dark:border-gray-700/60">
                    <div className="flex justify-between items-center">
                        {title && <div className="font-semibold text-gray-800 dark:text-gray-100">{title}</div>}

                        <button
                            className="text-gray-400 dark:text-gray-500 hover:text-gray-500 dark:hover:text-gray-400"
                            onClick={onClose}
                        >
                            <div className="sr-only">Close</div>
                            <svg className="fill-current" width="16" height="16" viewBox="0 0 16 16">
                                <path
                                    d="M7.95 6.536l4.242-4.243a1 1 0 111.415 1.414L9.364 7.95l4.243 4.242a1 1 0 11-1.415 1.415L7.95 9.364l-4.243 4.243a1 1 0 01-1.414-1.415L6.536 7.95 2.293 3.707a1 1 0 011.414-1.414L7.95 6.536z"></path>
                            </svg>
                        </button>
                    </div>
                </div>

                <div className="px-5 py-4">
                    <div>{children}</div>
                </div>
            </div>
        </div>,
        document.body
    );
}

export default BillingModal;
